angular.module('tgaAdmin')
  .service('flashService', [
    function () {
      let queue = [];
      let current = [];

      return {
        set(message, type, persist) {
          queue.push({
            message,
            type,
            persist,
          });
        },
        get() {
          if (queue.length > 0) {
            current = queue;
            queue = [];
          } else {
            current = [];
          }

          return current;
        },
      };
    }]);
